// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1m-m3","footer":"ModalUpdate_footer__K28tu"};